import { NpoPlayerEvent } from '../../types/events';
import { handleSegmentTimeChanged } from './handleSegmentTimeChanged';
import { handleSegmentSeek } from './handleSegmentSeek';
export const addSegmentEventListeners = (playerContext, segment) => {
    const segmentHandleTimeChangedCallback = handleSegmentTimeChanged(playerContext, segment);
    const segmentSeekFunctionCallback = handleSegmentSeek(playerContext, segment);
    const { player, npoplayer } = playerContext;
    player.on(NpoPlayerEvent.TimeChanged, segmentHandleTimeChangedCallback);
    player.on(NpoPlayerEvent.Seek, segmentSeekFunctionCallback);
    npoplayer.eventListeners = {
        segmentHandleTimeChangedCallback,
        segmentSeekFunctionCallback
    };
};
